// @flow
import { Field } from 'redux-form'
// import FormField from './FormField'
import FieldForm from '../form/FieldForm'

/**
 * @deprecated
 */
export default class McField extends Field {
    static defaultProps = {
        component: FieldForm
    }
}
